module.exports = __webpack_public_path__ + "assets/search-icon-3756fb.svg";